import { databasesToContentId } from './constants';
import { databaseForCopyAndPasteWithUserField } from './databaseForCopyAndPasteWithUserField';
import { databaseWithBasicFields } from './databaseWithBasicFields';
import { getDatabaseWithContent } from './databaseWithContent';
import { getDatabaseWithFilters } from './databaseWithFilters';
import { getDatabaseWithSampleCsvStructure } from './databaseWithSampleCsvStructure';
import { getDatabaseWithSmallCsvStructureWithUgc } from './databaseWithSampleCsvStructureWithUgc';
import { getDatabaseWithSelfReferenceEntryLinkField } from './databaseWithSelfReferenceEntryLinkField';
import { getDatabaseWithUserAndLinkField } from './databaseWithUserAndLinkField';
import { databaseWithViewsOverflow } from './databaseWithViewsOverflow';
import { getEmptyDatabase } from './emptyDatabase';
import { getEmptyDatabaseWithNewLineEnabled } from './emptyDatabaseWithNewLineEnabled';

export default {
  emptyDatabase: {
    database: getEmptyDatabase(),
    contentId: databasesToContentId['emptyDatabase'],
  },
  databaseWithViewsOverflow: {
    database: databaseWithViewsOverflow(),
    contentId: databasesToContentId['databaseWithViewsOverflow'],
  },
  databaseWithSampleCsvStructure: {
    database: getDatabaseWithSampleCsvStructure(),
    contentId: databasesToContentId['databaseWithSampleCsvStructure'],
  },
  databaseWithSampleCsvStructureWithUgc: {
    database: getDatabaseWithSmallCsvStructureWithUgc(),
    contentId: databasesToContentId['databaseWithSampleCsvStructureWithUgc'],
  },
  databaseWithContent: {
    database: getDatabaseWithContent(),
    contentId: databasesToContentId['databaseWithContent'],
  },
  databaseForCopyAndPasteWithUserField: {
    database: databaseForCopyAndPasteWithUserField(),
    contentId: databasesToContentId['databaseForCopyAndPasteWithUserField'],
  },
  emptyDatabaseWithNewLineEnabled: {
    database: getEmptyDatabaseWithNewLineEnabled(),
    contentId: databasesToContentId['emptyDatabaseWithNewLineEnabled'],
  },
  databaseWithBasicFields: {
    database: databaseWithBasicFields(),
    contentId: databasesToContentId['databaseWithBasicFields'],
  },
  databaseWithUserAndLinkField: {
    database: getDatabaseWithUserAndLinkField(),
    contentId: databasesToContentId['databaseWithUserAndLinkField'],
  },
  databaseWithSelfReferenceEntryLinkField: {
    database: getDatabaseWithSelfReferenceEntryLinkField(),
    contentId: databasesToContentId['databaseWithSelfReferenceEntryLinkField'],
  },
  databaseWithFilters: {
    database: getDatabaseWithFilters(),
    contentId: databasesToContentId['databaseWithFilters'],
  },
};
